import React from 'react'
//Helpers
import useQueryProperty from '@hooks/useQueryProperty'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import { saveAs } from 'file-saver'
import { ElementHTML, getFile } from '@helpers/helper.rendering'
import './index.scss'

const fileZone_1 = ({
  propertyID,
  developmentID,
  global_data,
  title,
  alignCenter,
  titleSecondary,
  titleElement,
  is_wide,
  image,
}: {
  propertyID: string
  developmentID: string
} & RealEstateDataPageComponentData) => {
  const { data, isLoading }: { data: Property | Development; isLoading: boolean } = propertyID
    ? useQueryProperty(propertyID, global_data.pageConfig.keys.tokko)
    : useQueryDevelopment(developmentID, global_data.pageConfig.keys.tokko)

  const icons: string = global_data.pageConfig.design.icons

  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const downloadImage = (url: string, name: string, ext: string) => {
    saveAs(url, name + ext) // Put your image url here.
  }

  return (
    (isLoading || data?.files?.length > 0) && (
      <section
        id="Descargas"
        className={
          'files-zone a p-y-config ' + (!isLoading && data?.files?.length === 0 ? 'd-none' : '')
        }
      >
        <div className="container-fluid">
          <div className="row intro pt-lg-0 mt-lg-5">
            <div className={is_wide ? 'col-lg-2' : 'col-lg-12'}>
              <ElementHTML
                children={title || 'Descargas'}
                elementType={titleElement || 'h2'}
                className={
                  'mb-5 section-title' +
                  (alignCenter ? ' text-center' : '') +
                  (titleSecondary ? ' secondary-color' : '')
                }
              />
            </div>
            <div className={is_wide ? 'col-lg-10' : 'col-lg-12'}>
              <div className="row">
                <div
                  className={
                    'col-12 d-lg-flex' +
                    (alignCenter ? ' justify-content-center' : ' justify-content-start')
                  }
                >
                  {isLoading
                    ? ''
                    : data?.files?.map((file, index) => (
                        <a
                          key={index}
                          target="_blank"
                          onClick={() =>
                            downloadImage(file.file, getFile(file).name, getFile(file).ext)
                          }
                          className={
                            'btn-file me-3 d-lg-inline-flex d-flex mb-3 align-items-center justify-content-center justify-content-lg-start'
                          }
                          href={file.file}
                          download
                        >
                          {!image && (
                            <i className={`order-lg-1 order-2 icon-download${iconsStyle}`}></i>
                          )}
                          <div className="ms-2 d-flex order-lg-2 order-1 name-file">
                            {file?.public_name || getFile(file).name + getFile(file).ext}
                          </div>
                          {image && (
                            <img
                              className="ms-3 order-lg-3 order-3"
                              src={image}
                            />
                          )}
                        </a>
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  )
}

export default fileZone_1
